import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import exactMath from 'exact-math';
import { shouldShowOppositeCurrency } from './currencyConfigStore';
export var bgnToEuro = function bgnToEuro(_ref) {
  var value = _ref.value,
      rate = _ref.rate,
      noLabel = _ref.noLabel;
  if (!value || value === '0.00') return noLabel ? '0.00' : '0.00 EUR';
  var courseRate = rate !== null && rate !== void 0 ? rate : 1.95583;
  var numberValue = Number(value);
  var convertedValue = exactMath.div(numberValue, courseRate, {
    maxDecimal: 2
  });
  return noLabel ? convertedValue : "".concat(convertedValue, " EUR");
};
export var eurToBgn = function eurToBgn(_ref2) {
  var value = _ref2.value,
      rate = _ref2.rate,
      noLabel = _ref2.noLabel;
  if (!value || value === '0.00') return noLabel ? '0.00' : '0.00 BGN';
  var courseRate = rate !== null && rate !== void 0 ? rate : 0.511292;
  var numberValue = Number(value);
  var convertedValue = exactMath.div(numberValue, courseRate, {
    maxDecimal: 2
  });
  return noLabel ? convertedValue : "".concat(convertedValue, " BGN");
};
export var convertToAdditionalCurrency = function convertToAdditionalCurrency(_ref3) {
  var value = _ref3.value,
      fromCurrency = _ref3.fromCurrency,
      noLabel = _ref3.noLabel;
  // Check if we should show opposite currency based on configuration
  if (!shouldShowOppositeCurrency()) return '';
  if (fromCurrency === 'BGN') return bgnToEuro({
    value: value,
    noLabel: noLabel
  });
  if (fromCurrency === 'EUR') return eurToBgn({
    value: value,
    noLabel: noLabel
  });
  return noLabel ? value : "".concat(value, " ").concat(fromCurrency);
};
export var oppositeCurrency = function oppositeCurrency(currency) {
  // Only show opposite currency if configuration allows it
  if (!shouldShowOppositeCurrency()) return currency;
  if (currency === 'BGN') return 'EUR';
  if (currency === 'EUR') return 'BGN';
  return currency;
};